<script>
import { onMount } from 'svelte';
import config from "./../../config.js";
import { user } from './../stores.js';
let pushButton;
let subscriptionDetails;
let subscriptionJson;
let current_user;
const unsubscribe = user.subscribe(value => {
    current_user = value;
});

const isEnabled = true;

// this public key is also in the sw.js file
const applicationServerPublicKey = 'BMJHTYrn_ie6FV8lLQy9qHgL1srfg4Yu_UgZuxuCrEBl8oXFgFOQPdIOSFm_QmQUXTd97J2bZ8qqvHrFhxO2yg8';

let isSubscribed = false;
let swRegistration = null;

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function updateBtn() {
  if (Notification.permission === 'denied') {
    pushButton.textContent = 'Push Messaging Blocked.';
    pushButton.disabled = true;
    updateSubscriptionOnServer(null);
    return;
  }

  if (isSubscribed) {
    pushButton.textContent = 'Disable Push Messaging';
  } else {
    pushButton.textContent = 'Enable Push Messaging';
  }

  pushButton.disabled = false;
}

async function postSubscription(subscription) {
    // const { api } = config;
		const res = await fetch("/api/v2/subscription/create", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': 'Bearer ' + current_user.token
      },
			body: JSON.stringify({payload: subscription})
    });
		
    if (res.ok) {
      const json = await res.json()
    } else {
      alert("HTTP-Error: " + response.status);
    }
}

function updateSubscriptionOnServer(subscription) {
  postSubscription(subscription)
  if (subscription) {
    subscriptionJson.textContent = JSON.stringify(subscription);
  }
}

function subscribeUser() {
  const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
  swRegistration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: applicationServerKey
  })
  .then(function(subscription) {
    console.log('User is subscribed.');

    updateSubscriptionOnServer(subscription);

    isSubscribed = true;

    updateBtn();
  })
  .catch(function(err) {
    console.log('Failed to subscribe the user: ', err);
    updateBtn();
  });
}

function unsubscribeUser() {
  swRegistration.pushManager.getSubscription()
  .then(function(subscription) {
    if (subscription) {
      return subscription.unsubscribe();
    }
  })
  .catch(function(error) {
    console.log('Error unsubscribing', error);
  })
  .then(function() {
    console.log('User is unsubscribed.');
    isSubscribed = false;

    updateBtn();
  });
}

function initializeUI() {
  if (!pushButton)
    return;
  pushButton.addEventListener('click', function() {
    pushButton.disabled = true;
    if (isSubscribed) {
      unsubscribeUser();
    } else {
      subscribeUser();
    }
  });

  // Set the initial subscription value
  swRegistration.pushManager.getSubscription()
  .then(function(subscription) {
    isSubscribed = !(subscription === null);

    if (isSubscribed) {
      console.log('User is subscribed.');
    } else {
      console.log('User is not subscribed.');
    }

    updateBtn();
  });
}

onMount(async () => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
        console.log('Service Worker and Push is supported');

        navigator.serviceWorker.register('sw.js')
        .then(function(swReg) {
            console.log('Service Worker is registered', swReg);

            swRegistration = swReg;
            initializeUI();
        })
        .catch(function(error) {
            console.error('Service Worker Error', error);
        });
    } else {
            console.warn('Push messaging is not supported');
            pushButton.textContent = 'Push Not Supported';
    }
});
</script>

<!-- {#if isEnabled} -->
<button bind:this={pushButton}>Subscribe to notifications</button>
<!-- {/if} -->
<section bind:this={subscriptionDetails} style="display: none;" class="subscription-details">
      <pre><code bind:this={subscriptionJson} class="js-subscription-json"></code></pre>
</section>

